import {
  ImageBackground,
  StyleProp,
  StyleSheet,
  ViewStyle,
} from 'react-native';
import Svg, { Defs, G, Path, Symbol, Use, Text } from 'react-native-svg';

import Colors from '../../constants/Colors';
import useColorScheme from '../../hooks/useColorScheme';
import { View } from '../Themed';

const config = {
  backgroundColor: '#E985A6',
  titleText: 'Gift Card',
  amount: 100,
};

export default function GiftCardV2({
  style,
}: {
  style?: StyleProp<ViewStyle>;
}) {
  const theme = useColorScheme();
  return (
    <View
      style={[
        styles.card,
        {
          shadowOpacity: 1,
          shadowColor: Colors[theme].shadow,
          shadowRadius: 10,
          backgroundColor:
            config.backgroundColor || Colors[theme].accentTertiary,
          position: 'relative',
        },
        style,
      ]}
    >
      <ImageBackground
        source={require('../../assets/images/hmd-text.png')}
        style={{
          width: '100%',
          height: '100%',
          maxHeight: '100%',
          position: 'absolute',
        }}
        imageStyle={{
          alignSelf: 'center',
          height: '70%',
        }}
        resizeMode="contain"
      />
      <Svg height="100%" width="100%" viewBox="0 0 544 340">
        <Defs>
          <Symbol id="logo" viewBox="0 0 123 45">
            <Path d="M76.2608 42.308L69.8301 40.7236C69.9985 40.0312 70.1633 39.348 70.3303 38.6647C71.1651 35.2569 72.007 31.8518 72.8251 28.4391C72.9623 27.8746 73.0243 27.2943 73.0095 26.7135C72.9543 25.0159 71.9217 24.1238 70.3492 24.0015C68.4245 23.852 66.9797 24.9139 66.5124 26.7911C65.5015 30.8472 64.515 34.9083 63.5181 38.9672C63.5048 39.0224 63.4811 39.0741 63.4482 39.1629L56.7059 37.5239L62.0559 15.6034L68.4964 17.1739C68.3295 17.8816 68.166 18.5753 67.992 19.3152C68.3085 19.1245 68.5803 18.9379 68.8709 18.7891C70.3603 18.0269 71.9448 17.934 73.5684 18.1478C74.5534 18.277 75.5112 18.5055 76.4104 18.9463C77.7915 19.624 78.7333 20.7033 79.3131 22.1138C79.3662 22.2431 79.4144 22.3744 79.4668 22.5037C79.4752 22.5225 79.4968 22.5365 79.4549 22.4918C80.2157 22.1425 80.922 21.6975 81.6905 21.497C84.8405 20.6733 87.8257 21.0436 90.4497 23.0849C91.7638 24.107 92.4757 25.5489 92.7901 27.1816C93.0644 28.6042 93.0518 30.0673 92.7531 31.4851C92.2955 33.6564 91.7554 35.8102 91.2371 37.9675C90.644 40.4364 90.0361 42.9011 89.4332 45.3673C89.4153 45.4134 89.3934 45.4578 89.3676 45.5L82.969 43.9372C83.1625 43.1415 83.3532 42.3562 83.5432 41.571C84.3816 38.1275 85.236 34.6889 86.0289 31.2357C86.1738 30.5779 86.1795 29.8971 86.0457 29.2369C85.797 28.0297 84.9279 27.4065 83.727 27.2473C82.2501 27.051 80.9325 27.3814 79.9635 28.5746C79.6533 28.9568 79.4396 29.4633 79.318 29.9467C78.3204 33.9218 77.3556 37.9053 76.3838 41.8861C76.3419 42.0174 76.3035 42.1501 76.2608 42.308ZM6.33847 35.4141L12.7273 34.1733L12.2991 31.9874C12.5303 32.1474 12.6966 32.299 12.8908 32.3919C13.5272 32.6972 14.1483 33.08 14.8211 33.2554C17.007 33.8247 19.1322 33.4412 21.1498 32.5435C24.7994 30.9199 26.692 27.9703 27.1747 24.0958C27.5464 21.1099 27.0224 18.247 25.593 15.5818C24.5046 13.5509 22.9474 11.9909 20.8047 11.0792C18.5461 10.1186 16.2134 10.0844 13.8521 10.6062C12.0881 10.9961 10.5525 11.7897 9.39213 13.2163C9.2014 13.451 9.03164 13.7053 8.81157 14.0008C8.21775 10.9744 7.6379 8.02205 7.05246 5.03896L0.679688 6.27831C2.56735 15.9995 4.45012 25.6914 6.33847 35.4141ZM10.7244 23.6201C9.89862 21.1476 10.934 18.3238 13.1591 17.1383C15.6587 15.8067 18.771 16.5019 20.1278 19.5911C20.8054 21.133 20.9277 22.723 20.3066 24.3103C19.5954 26.1267 18.2017 27.0873 16.2931 27.3374C16.0835 27.3646 15.8739 27.3632 15.7083 27.373C13.4539 27.3688 11.4761 25.8654 10.7244 23.6201ZM101.54 22.2543C99.1936 23.8611 97.6455 26.0477 97.0083 28.8212C96.374 31.5787 96.6639 34.2949 97.723 36.9021C99.5143 41.3097 102.91 43.6165 107.567 44.0092C111.004 44.2984 114.141 43.328 116.836 41.1274C118.958 39.3948 120.237 37.1508 120.679 34.4423C120.954 32.7656 120.872 31.1015 120.52 29.4465C120.031 27.146 119.088 25.0704 117.433 23.3685C115.128 20.9933 112.243 20.0152 109.504 19.9593C106.282 19.9754 103.784 20.7166 101.54 22.2543ZM113.684 29.5122C114.222 30.9094 114.458 32.3402 114.038 33.8143C113.452 35.8668 112.053 37.0977 110.011 37.5449C107.969 37.992 106.15 37.4967 104.732 35.8898C103.754 34.786 103.393 33.4356 103.317 31.9979C103.226 30.2876 103.759 28.8017 105.054 27.6567C106.132 26.703 107.43 26.2657 108.868 26.2594C111.09 26.242 112.882 27.4422 113.684 29.5122ZM55.8836 13.073L49.0798 11.6618C49.0393 11.847 49.0099 11.9713 48.9855 12.0964C48.1967 15.9388 47.4185 19.7812 46.6158 23.6159C46.2916 25.1654 45.5483 26.4418 44.0581 27.1578C42.2934 28.006 40.2737 27.3395 39.4473 25.6258C39.0016 24.7029 38.9233 23.7088 39.1168 22.7237C39.7931 19.2816 40.5078 15.8466 41.2078 12.4094C41.3594 11.6618 41.5089 10.9143 41.6654 10.1389L35.1738 8.81149C35.0341 9.48356 34.8993 10.1193 34.7721 10.7557C33.9778 14.726 33.1535 18.6892 32.4066 22.6657C32.0874 24.2959 32.1401 25.9771 32.561 27.584C33.0417 29.392 34.0547 30.7976 35.681 31.738C37.218 32.6245 38.8884 33.0297 40.6454 33.1024C42.2788 33.1722 43.7815 32.7719 45.0949 31.7596C45.1616 31.7204 45.2317 31.6874 45.3045 31.6611C45.1494 32.4086 45.0097 33.1107 44.8699 33.8436L51.3629 35.171C52.8684 27.8013 54.3711 20.4525 55.8836 13.073ZM38.3386 4.00641C38.3386 5.94856 39.9321 7.47923 41.9581 7.48552C43.9729 7.4925 45.5378 5.93459 45.5525 3.90651C45.5686 1.9937 43.9142 0.511233 41.7527 0.500055C39.7889 0.489576 38.3379 1.98042 38.3386 4.00641ZM52.0936 2.60918C49.7337 2.62245 48.6515 4.52408 48.6432 5.95555C48.6421 6.4329 48.7354 6.90575 48.9176 7.34696C49.0998 7.78817 49.3674 8.18905 49.7049 8.52659C50.0425 8.86412 50.4433 9.13168 50.8846 9.31388C51.3258 9.49609 51.7986 9.58936 52.276 9.58835C54.2656 9.57927 55.8459 8.01646 55.8431 6.06104C55.8403 4.10561 54.209 2.5994 52.0936 2.61127V2.60918Z" />
          </Symbol>
          <Symbol id="flower" viewBox="0 0 89 88">
            <G mask="url(#mask0_728_12126)">
              <Path
                d="M75.6553 33.9687C67.5394 38.5182 58.5582 41.4698 49.9046 44.7999C58.2137 46.7761 80.5954 50.5602 84.9642 57.0102C87.115 60.0207 85.7372 64.5113 81.6876 65.2597C69.5222 66.0417 58.2809 58.8014 49.1485 51.9898C48.6444 51.8216 49.2157 52.7046 49.2409 52.8728C53.7273 63.6199 58.4994 74.3333 61.692 85.5008C61.7172 85.5849 61.734 85.669 61.7508 85.7531C62.3221 88.9234 61.3475 91.7826 58.3902 91.2612C57.6172 91.1267 56.9031 90.7651 56.3486 90.2437C46.4348 81.0271 44.1579 66.6977 40.5453 54.5631C36.2857 64.8644 33.4964 76.0404 27.4053 85.5765C25.5401 88.3684 20.3816 89.0916 19.113 86.1652C14.7358 76.0488 22.7928 60.0964 28.6319 51.418C28.7327 51.1741 29.3376 50.5266 28.8083 50.493C-9.92276 55.3704 -7.34349 34.4565 34.1601 39.5861C8.9723 -3.83102 39.4363 -20.9607 42.0744 38.905C42.0912 39.1152 42.1248 39.5693 42.444 39.3759C64.6745 15.0899 94.0211 21.8005 75.6553 33.9687Z"
                fill="#E4F1E2"
              />
            </G>
          </Symbol>
        </Defs>
        <Use
          href="#flower"
          width="86"
          height="91"
          x={100}
          y={-3}
          fill="#E4F1E2"
        />
        <Use
          href="#flower"
          width="86"
          height="91"
          x={10}
          y={180}
          fill="#E4F1E2"
        />
        <Use
          href="#flower"
          width="86"
          height="91"
          x={410}
          y={10}
          fill="#E4F1E2"
        />
        <Use
          href="#flower"
          width="86"
          height="91"
          x={410}
          y={10}
          fill="#E4F1E2"
        />
        <Use
          href="#flower"
          width="86"
          height="91"
          x={450}
          y={140}
          fill="#E4F1E2"
        />
        <Use
          href="#logo"
          width="108"
          height="59"
          x={544 / 2 - 108 / 2}
          y={10}
          fill="rgb(245,235,118)"
        />
        <Use
          href="#hmd-text"
          x={544 / 2 - 246 / 2}
          y={344 / 2 - 232 / 2}
          width={246}
          height={232}
        />
        <Text
          textAnchor="end"
          fontFamily="Mont"
          fontWeight="900"
          fontSize={80}
          fontStretch="ultra-expanded"
          fill="#fff"
          x={531}
          y={320}
        >
          $50
        </Text>
      </Svg>
    </View>
  );
}

const styles = StyleSheet.create({
  card: {
    aspectRatio: 1.6,
    borderRadius: 20,
    overflow: 'hidden',
    justifyContent: 'center',
    alignItems: 'center',
  },
});
